module.exports = "pegasus_template/assets/themelp1/charity/106.png";